{
  "name": "codex-workspace-switcher",
  "version": "2.1.8",
  "private": true,
  "description": "Desktop app for switching between OpenAI Codex workspace auth profiles.",
  "main": "dist-electron/main.js",
  "scripts": {
    "dev": "concurrently -k \"npm:dev:renderer\" \"npm:dev:main\" \"npm:dev:electron\"",
    "dev:host": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\restart-dev.ps1 -Mode DevHostBrowserStart",
    "dev:host:fresh": "concurrently -k \"npm:dev:renderer:host\" \"npm:dev:main\" \"npm:dev:electron:host\"",
    "dev:host:reuse-renderer": "concurrently -k \"npm:dev:main\" \"npm:dev:electron:host\"",
    "dev:renderer": "vite --host 127.0.0.1 --port 5173 --strictPort",
    "dev:renderer:host": "vite --host 127.0.0.1 --port 5175 --strictPort",
    "dev:main": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\build-electron.ps1 --sourcemap --watch",
    "dev:electron": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\restart-dev.ps1 -Mode DevElectronLoop",
    "dev:electron:host": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\restart-dev.ps1 -Mode DevElectronLoop -ElectronArgs 'license-host-mode'",
    "build:resources": "node .\\scripts\\prepare-build-assets.mjs",
    "typecheck": "tsc --noEmit",
    "test:profile-health": "node .\\scripts\\run-profile-health-tests.cjs",
    "build:renderer": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\build-renderer.ps1",
    "build:electron": "powershell -NoProfile -ExecutionPolicy Bypass -File .\\scripts\\build-electron.ps1",
    "build": "powershell -ExecutionPolicy Bypass -File .\\scripts\\build.ps1",
    "dist": "powershell -ExecutionPolicy Bypass -File .\\scripts\\dist.ps1 -Target win",
    "dist:win": "powershell -ExecutionPolicy Bypass -File .\\scripts\\dist.ps1 -Target win",
    "dist:win:local-fast": "powershell -ExecutionPolicy Bypass -File .\\scripts\\dist.ps1 -Target win -Variant local-fast",
    "dist:mac": "powershell -ExecutionPolicy Bypass -File .\\scripts\\dist.ps1 -Target mac",
    "dist:dir": "powershell -ExecutionPolicy Bypass -File .\\scripts\\dist.ps1 -Target dir",
    "release:manifest": "node ..\\Cloudflare\\scripts\\release-manifest.mjs --channel stable",
    "release:manifest:beta": "node ..\\Cloudflare\\scripts\\release-manifest.mjs --channel beta"
  },
  "dependencies": {
    "@fontsource/space-grotesk": "^5.2.10",
    "@radix-ui/react-dialog": "^1.1.15",
    "@radix-ui/react-progress": "^1.1.8",
    "clsx": "^2.1.1",
    "fs-extra": "^11.3.4",
    "lucide-react": "^0.577.0",
    "nanoid": "^5.1.6",
    "react": "^19.2.4",
    "react-dom": "^19.2.4"
  },
  "devDependencies": {
    "@tailwindcss/postcss": "^4.2.1",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^25.5.0",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.0",
    "autoprefixer": "^10.4.27",
    "concurrently": "^9.2.1",
    "cross-env": "^10.1.0",
    "electron": "^41.0.2",
    "electron-builder": "^26.8.1",
    "esbuild": "^0.27.4",
    "postcss": "^8.5.8",
    "tailwindcss": "^4.2.1",
    "typescript": "^5.9.3",
    "vite": "^8.0.0",
    "wait-on": "^9.0.4",
    "wrangler": "^4.75.0"
  },
  "build": {
    "appId": "com.jerryc0820.auth-api-switcher",
    "productName": "Ainivox Switch",
    "executableName": "Auth.API.Switcher",
    "afterPack": "./scripts/electron-builder-after-pack.cjs",
    "directories": {
      "output": "release-artifacts",
      "buildResources": "build"
    },
    "files": [
      "dist/**/*",
      "dist-electron/**/*",
      "package.json"
    ],
    "extraMetadata": {
      "main": "dist-electron/main.js"
    },
    "win": {
      "target": [
        "nsis"
      ],
      "icon": "build/icon.ico",
      "signAndEditExecutable": false,
      "artifactName": "Auth.API.Switcher-${version}-win-${arch}.${ext}"
    },
    "mac": {
      "target": [
        "dmg",
        "zip"
      ],
      "icon": "build/icon.png",
      "artifactName": "Auth.API.Switcher-${version}-mac-${arch}.${ext}",
      "category": "public.app-category.developer-tools"
    },
    "nsis": {
      "oneClick": false,
      "allowToChangeInstallationDirectory": true,
      "runAfterFinish": true,
      "createDesktopShortcut": true,
      "createStartMenuShortcut": true,
      "include": "build/installer-hooks.nsh",
      "installerIcon": "build/installerIcon.ico",
      "uninstallerIcon": "build/uninstallerIcon.ico",
      "installerHeaderIcon": "build/installerHeaderIcon.ico",
      "license": "build/license.txt"
    },
    "dmg": {
      "sign": false,
      "contents": [
        {
          "x": 180,
          "y": 220
        },
        {
          "x": 460,
          "y": 220,
          "type": "link",
          "path": "/Applications"
        }
      ]
    }
  }
}
